import { APIEnvironment, HeadingTags, Region, TileLayout } from '@migros/msrc-articles';
import { SupportedLanguages } from '@migros/msrc-i18n';
import appConfig from 'helper/mapBackendConfig';

// shared config between different widget types i.e. product, slider...
// - disable _blank in the Android App, see https://jira.migros.net/browse/PULSAPP-668
const MsrcWidgetsSharedConfig = {
	webAPIKey: appConfig.env.msrc.webApiKey,
	language: SupportedLanguages[appConfig.env.language],
	filterOptions: {
		fo: {
			anchor_target: '_self',
		},
		region: Region.national,
	},
	environment: (() => {
		switch (appConfig.env.id) {
			case 'LOCAL':
				// don't use APIEnvironment.local here, because widget would not show images
				return APIEnvironment.test;
			case 'DEV':
				return APIEnvironment.test;
			case 'TEST':
				return APIEnvironment.test;
			default:
				return APIEnvironment.production;
		}
	})(),
};

export const ProductSliderWidgetConfig = {
	...MsrcWidgetsSharedConfig,
	theme: 'gesundheitsplattform',
	tilesVisibleCount: [2.5], // list layout per viewports
	disableLazyLoad: true,
};

export const ProductWidgetConfig = {
	...MsrcWidgetsSharedConfig,
	layout: TileLayout.mini,
	headingTagsLevel: HeadingTags.h2,
	trackingInfo: 'impuls-coach',
	hideRating: true,
};
